import { defineNuxtPlugin } from "#app";
import ToastService from "primevue/toastservice";

export default defineNuxtPlugin((nuxtApp) => {
  if (!nuxtApp.vueApp.config.globalProperties.$toast) {
    nuxtApp.vueApp.use(ToastService);
  }
});
